module.exports = __webpack_public_path__ + "img/stat3.7e5b4937.svg";